import React from "react";
import { Box, Typography } from "@mui/material";
import { Calendar } from "lucide-react";
import moment from "moment";

const DateChip = ({ date, label }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minWidth: label ? "130px" : "110px",
        maxWidth: label ? "180px" : "140px",
        gap: 0.5,
        backgroundColor: "#F8FAFC",
        padding: "6px 12px",
        borderRadius: "12px",
        border: "1px solid #E2E8F0",
        transition: "all 0.2s ease",
        boxShadow: "0 1px 2px rgba(0, 0, 0, 0.04)",
        whiteSpace: "nowrap",
        overflow: "hidden",
        "&:hover": {
          backgroundColor: "#F1F5F9",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.08)",
          borderColor: "#CBD5E1",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "20px",
          height: "20px",
          borderRadius: "6px",
          backgroundColor: "#EFF6FF",
          color: "#2563EB",
        }}
      >
        <Calendar size={12} />
      </Box>
      <Typography
        sx={{
          fontSize: "12px",
          fontWeight: 500,
          color: "#475569",
          fontFamily: "Inter, sans-serif",
          display: "flex",
          alignItems: "center",
          gap: 0.5,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {label && (
          <span
            style={{
              color: "#64748B",
              fontSize: "11px",
              fontWeight: 400,
              flexShrink: 0,
            }}
          >
            {label}:
          </span>
        )}
        <span
          style={{
            flexShrink: 1,
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {date && moment(date).isValid()
            ? moment(date).format("MMM D, YYYY")
            : date || "N/A"}
        </span>
      </Typography>
    </Box>
  );
};

export default DateChip;
